enum TrustedPortalPubSubEventEnum {
  TRUSTED_PORTAL_PROVIDE_EVENT = 'TRUSTED_PORTAL_PROVIDE_EVENT',
  TRUSTED_PORTAL_EVENT_PROVIDED = 'TRUSTED_PORTAL_EVENT_PROVIDED',
  TRUSTED_PORTAL_LOAD_EVENTS = 'TRUSTED_PORTAL_LOAD_EVENTS',
  TRUSTED_PORTAL_EVENTS_LOADED = 'TRUSTED_PORTAL_EVENTS_LOADED',
  TRUSTED_PORTAL_NO_EVENTS = 'TRUSTED_PORTAL_NO_EVENTS'
}

export default TrustedPortalPubSubEventEnum;
